import React from 'react';
import Layout from '../components/Layout';
import SupplierList from '../components/SupplierList';
import { 
  Title,
  Card,
  CardHeader,
  Breadcrumbs,
  BreadcrumbsItem,
  Avatar,
  Icon
} from '@ui5/webcomponents-react';

/**
 * Página de gestión de proveedores
 */
const Suppliers = () => {
  return (
    <Layout>
      <div style={{ 
        padding: '1.5rem',
        backgroundColor: 'var(--sapBackgroundColor)',
        minHeight: '100vh'
      }}>


        {/* Page Header */}
        <Card style={{ marginBottom: '1.5rem' }}>
          <CardHeader
            titleText="Gestión de Proveedores"
            subtitleText="Administra y gestiona todos los proveedores de la empresa"
            avatar={
              <Avatar 
                style={{ 
                  backgroundColor: 'var(--sapAccentColor6)',
                  color: 'white'
                }}
              >
                <Icon name="supplier" />
              </Avatar>
            }
          />
        </Card>

        {/* Main Content */}
        <SupplierList />
      </div>
    </Layout>
  );
};

export default Suppliers;